import map from 'lodash/map';
import React, {ChangeEvent, useEffect} from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../hooks/redux';
import { setLang } from '../../store/reducers/LanguageSlice';
import styles from './index.module.css';

const languages = ['ru', 'uz'];

interface IProps {
	value: string;
}

export const LanguageSelect = ({ value }: IProps) => {
	const dispatch = useAppDispatch();
	const { t, i18n } = useTranslation('translation');

	useEffect(() => {
		i18n.changeLanguage(value);
	}, [value]);

	const handleSelect = (event: ChangeEvent & {target: HTMLSelectElement}) => {
		dispatch(setLang(event.target.value));
	};

	return (
		<select className={styles.select} name="categorySelect" value={value} onChange={handleSelect} id="categorySelect">
			{map(languages, l => (
				<option value={l} key={l}>{t(l)}</option>
			))}
		</select>
	);
};
